import * as Yup from 'yup';
import { sumUnitQty, optionEntryId } from './optionQty';

// Per-group Yup schemas for ProductForm's dynamic validation.
// Flag off: today's array-length rules, byte-identical messages.
// allowquantities: min/max compare the SUM of unit quantities (Rule 2).
export const buildOptionGroupSchemas = (optionGroups = []) =>
  optionGroups.reduce(function (obj, itm) {
    obj[itm.id] = itm.allowquantities
      ? Yup.array()
          .test(
            'min-units',
            `You have to select minimum ${itm.min}.`,
            (arr) => sumUnitQty(arr || []) >= itm.min,
          )
          .test(
            'max-units',
            `You can select maximum ${itm.max}.`,
            (arr) => sumUnitQty(arr || []) <= itm.max,
          )
      : Yup.array()
          .min(itm.min, `You have to select minimum ${itm.min}.`)
          .max(itm.max, `You can select maximum ${itm.max}.`);
    return obj;
  }, {});

// Initial Formik value per option group when editing a basket line.
// Toggle groups keep today's string[] of option ids; allowquantities groups
// carry {id, qty} with the persisted unit count. Legacy localStorage carts
// predate the qty field -> qty ?? 1. Options turned invisible in the
// dashboard since the cart was saved are dropped (today's behavior).
export const buildOptionGroupInitialValues = (
  optionGroups = [],
  basketProduct,
) =>
  optionGroups.reduce(function (obj, itm) {
    obj[itm.id] = basketProduct
      ? itm.options
          .map((option) => {
            if (option.visible === false) return null;
            const isAdded = (basketProduct.options || []).find(
              (a) => a.id === option.id,
            );
            if (!isAdded) return null;
            return itm.allowquantities
              ? { id: isAdded.id, qty: isAdded.qty ?? 1 }
              : isAdded.id;
          })
          .filter(Boolean)
      : [];
    return obj;
  }, {});

// A group that allows exactly one unit (max == 1) replaces its previous pick
// when the customer taps a different option, instead of disabling the rest.
// Segment's single mode (flag off) already replaces; its quantity mode
// APPENDS {id, qty: 1}, so for max-1 allowquantities groups the newly added
// entry is kept alone. Everything else (max 0 / >= 2, deselect, qty change on
// the selected option) passes through untouched.
export const resolveOptionGroupChange = (group, prevValue = [], nextValue) => {
  if (!group?.allowquantities || group.max !== 1) return nextValue;
  const prev = Array.isArray(prevValue) ? prevValue : [];
  const next = Array.isArray(nextValue) ? nextValue : [];
  const added = next.filter(
    (entry) => !prev.some((p) => optionEntryId(p) === optionEntryId(entry)),
  );
  return added.length === 1 ? [{ id: optionEntryId(added[0]), qty: 1 }] : next;
};
